import React, { useRef, useState, useMemo, useEffect } from 'react';
import echarts from 'echarts/lib/echarts';
// Import renderer, note that introducing the CanvasRenderer or SVGRenderer is a required step!
import ReactEChartsCore from 'echarts-for-react/lib/core';
import { motion } from 'framer-motion';
import CustomTooltip from './customTooltip';
import ReactDOM from 'react-dom';
import { useIsDesktop } from '../../../hooks/useMediaQuery';

// Register the required components reduce bundle size...

// interface PieChartProps {
//   data: PieSeriesOption['data'];
//   name: string;
//   minRadius?: number;
//   borderTop?: number;
//   borderBottom?: number;
// }
const COUNT_UP_DURATION = 0.75;
const NormalPieChart = ({
  data,
  name,
  minRadius = 50,
  borderTop = 18,
  borderBottom = 18,
  transitionDuration = COUNT_UP_DURATION,
  silentMouseEvents,
}) => {
  const timeoutRef = useRef(null);
  const pieRef = useRef(null);
  const isDesktop = useIsDesktop();
  const [enteredViewPort, setEnteredViewPort] = useState(false);
  const borderRadius = [borderBottom, borderTop];
  const [tooltipState, setTooltipState] = useState({
    show: false,
  });

  const defaultSeriesOption = {
    name,
    silent: silentMouseEvents,
    type: 'pie',
    radius: [`${minRadius}%`, '90%'],
    avoidLabelOverlap: false,
    itemStyle: {
      borderColor: '#fff',
      borderWidth: 0,
      // shadowBlur: 3,
      // shadowOffsetX: 0,
      // shadowColor: 'rgba(0, 0, 0, 0.5)',
    },
    label: {
      show: false,
      position: 'center',
    },
    emphasis: {
      label: {
        show: false,
      },
      scaleSize: 3,
      itemStyle: {
        borderColor: '#fff',
        borderWidth: 0,
      },
    },
    labelLine: {
      show: false,
    },
    stillShowZeroSum: false,
    data,
  };
  const defaultOption = {
    // tooltip: {
    //   trigger: 'item',
    //   triggerOn: 'mousemove|click',
    //   confine: true,
    //   formatter: params => {
    //     if (params.name === 'empty' || params.name === 'padding') {
    //       return '';
    //     }
    //     return `<div class='flex items-center gap-x-1'>
    //               <div class='w-3 h-3 mr-0.5 rounded' style='background-color:${
    //                 params.color
    //               }'></div>
    //               <h1>${params.name}</h1>
    //               <strong class='text-end'>${params.value}%</strong>
    //             </div>`;
    //   },
    // },
    series: defaultSeriesOption,
  };
  const onEvents = useMemo(
    () => ({
      mouseover: eventData => {
        const { name } = eventData;
        if (name === 'empty' || name === '' || name === 'padding') {
          setTooltipState({ show: false });
        } else {
          const {
            color,
            value,
            data: { codigoPartido, cargos },
          } = eventData;
          setTooltipState({
            show: true,
            name,
            color,
            cargos,
            value,
            codigoPartido,
          });
        }
      },
      mouseout: () => {
        setTooltipState({ show: false });
      },
      globalout: () => {
        setTooltipState({ show: false });
      },
    }),
    []
  );

  useEffect(
    () => () => {
      timeoutRef.current && clearTimeout(timeoutRef.current);
    },
    []
  );

  return (
    <>
      {isDesktop ? (
        ReactDOM.createPortal(
          <CustomTooltip pieRef={pieRef} {...tooltipState} />,
          document.getElementById('root')
        )
      ) : (
        <CustomTooltip pieRef={pieRef} {...tooltipState} />
      )}
      <motion.div
        initial={{ height: '0%' }}
        animate={{ height: '100%' }}
        transition={{ duration: transitionDuration }}
        onAnimationStart={() => {
          timeoutRef.current = setTimeout(() => {
            setEnteredViewPort(true);
            timeoutRef.current = null;
          }, COUNT_UP_DURATION * 1000);
        }}
        style={{ aspectRatio: '1/1' }}
      >
        {enteredViewPort && (
          <ReactEChartsCore
            echarts={echarts}
            option={defaultOption}
            style={{ height: '100%' }}
            ref={pieRef}
            onEvents={onEvents}
          />
        )}
      </motion.div>
    </>
  );
};
export default NormalPieChart;
